import { render, staticRenderFns } from "./WoodFinish.vue?vue&type=template&id=2415e6b2"
import script from "./WoodFinish.vue?vue&type=script&lang=js"
export * from "./WoodFinish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports